import { render, staticRenderFns } from "./ZCFGDetailInfo.vue?vue&type=template&id=c9def0b6&scoped=true&"
import script from "./ZCFGDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ZCFGDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZCFGDetailInfo.vue?vue&type=style&index=0&id=c9def0b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9def0b6",
  null
  
)

export default component.exports